import { EXTERNAL_ID_PROVIDER } from '~/constants/documents';

export const addLanguageToFileName = (fileName, language) => {
  const parts = fileName.split('.');
  if (parts.length > 1) {
    const extension = `.${parts.pop()}`;
    const nameWithoutExtension = parts.join('.');
    return `${nameWithoutExtension}_${language}${extension}`;
  }
  return `${fileName}_${language}`;
};

// returns fileName extension
const getExtension = (filename) => filename.split('.').slice(-1)[0].toLowerCase();

export const isPdfExtension = (filename) => getExtension(filename) === 'pdf';

// returns true if it is an uploaded document (it is not in open search)
export const isTempDocument = (externalId) => externalId.includes('isTemp');

const getExternalIdProvider = (externalId) => externalId.split('/')[0];

export const isVeevaDocument = (externalId) => getExternalIdProvider(externalId) === EXTERNAL_ID_PROVIDER.veeva;
export const isUserDocument = (externalId) => getExternalIdProvider(externalId) === EXTERNAL_ID_PROVIDER.users;
export const isS3Document = (externalId) => getExternalIdProvider(externalId) === EXTERNAL_ID_PROVIDER.s3;
export const isAuthoringDocument = (externalId) => {
  const provider = getExternalIdProvider(externalId);
  return provider === EXTERNAL_ID_PROVIDER.authoring || provider === EXTERNAL_ID_PROVIDER.authored;
};
export const isEmailDocument = (externalId) => getExternalIdProvider(externalId) === EXTERNAL_ID_PROVIDER.email;

export const mapMetadataFields = (reference, metadataFields) => {
  return {
    ...metadataFields,
    ...reference,
    sourceUrl: metadataFields?.sourceUrl?.href || metadataFields?.sourceUrl || '',
  };
};

/**
 * Resolves a language code to one present in the source languages list.
 * If the code is not in the list and contains '-' (variant, e.g. pt-PT, en-US),
 * returns the base part if it exists in the list; otherwise returns the original code.
 * @param {string} code - Language code (e.g. "pt-PT", "en")
 * @param {Array<{ language: string }>} sourceLanguages - List of available source languages
 * @returns {string} A code that exists in sourceLanguages, or the original code
 */
export const resolveLanguageCodeForSourceList = (code, sourceLanguages) => {
  if (!code || !sourceLanguages?.length) return code;
  const isInList = sourceLanguages.some((lang) => lang.language === code);
  if (isInList) return code;
  if (code.includes('-')) {
    const base = code.split('-')[0];
    const baseInList = sourceLanguages.some((lang) => lang.language === base);
    if (baseInList) return base;
  }
  return code;
};

// Ensure anchors open in a new tab
export const ensureLinksOpenInNewTab = (html) => html.replace(/<a(?![^>]*\starget=)/gi, '<a target="_blank"');
